import {
  sortingToteIdFormat,
  stationProcessingSessionIdFormat,
} from "@redotech/redo-ids-cockroach";
import * as z from "zod";
import { StationProcessingSessionToteBindingViewSchema } from "./station-processing-session";

export const unbindSortingTote = {
  name: "unbindSortingTote" as const,
  input: z.object({
    sessionId: stationProcessingSessionIdFormat.schema,
    sortingToteId: sortingToteIdFormat.schema,
  }),
  output: z.object({
    bindings: z.array(StationProcessingSessionToteBindingViewSchema),
  }),
};
